export const SIGN_UP_DATA = "SIGN_UP_DATA"
export const PREFERENCE_TAGS = "PREFERENCE_TAGS"
